import Cart from "@/components/Cart/Cart";
import Footer from "@/components/Footer/Footer";
import { LoginModalProvider } from "@/components/LoginModal/LoginModalProvider";
import { UploadModalProvider } from "@/components/UploadModal/UploadModalProvider";
import WelcomeNotice from "@/components/WelcomeNotice/WelcomeNotice";
import { $cart, CartService } from "@/stores/cart";
import { useStore } from "@nanostores/react";
import { PropsWithChildren } from "react";
import { Outlet, useLocation } from "react-router-dom";

const FOOTER_PATHNAMES = ["/upload"];

function Providers({ children }: PropsWithChildren) {
  return (
    <LoginModalProvider>
      <UploadModalProvider>
        <>{children}</>
      </UploadModalProvider>
    </LoginModalProvider>
  );
}

export default function AppLayout() {
  const cart = useStore($cart);
  const { pathname } = useLocation();
  const showFooter = FOOTER_PATHNAMES.some(path => pathname.startsWith(path));

  return (
    <Providers>
      <div className="flex flex-col md:h-dvh">
        <Outlet />
        <WelcomeNotice />
        {showFooter && <Footer className="mt-auto" />}
        {cart.isOpen && (
          <div className="absolute inset-0 z-[8000] animate-fade-in duration-500">
            <div
              className="size-full bg-black/60"
              onClick={() => CartService.toggleCart(false)}
            />
            <aside className="fixed right-0 top-0 h-full w-full transform animate-slide-in-right bg-white sm:w-[485px]">
              <Cart />
            </aside>
          </div>
        )}
      </div>
    </Providers>
  );
}
